import React, { Component } from 'react'
import ReactDOM from 'react-dom';
import { PropTypes } from 'prop-types'
import {
    getSelectOptions,
    updateComponent,
    fetchData
} from '../../state/actions/componentsActions'
import { connect } from 'react-redux'
import Select from 'react-select'
//import 'react-select/dist/react-select.css'
import './styles.css'
import { camelize } from '../../utils'
import { css, withStyles } from '../../styles/withStyles'
import Styles from './styles'



export class DropDownSearch extends Component {
    constructor(props) {
        super(props)
    }
    componentWillMount() {
        if (
            this.props.component.hasOwnProperty('options') &&
            (this.props.component.values || []).length === 0 &&
            !this.props.component.fetchInProgress
        ) {
            const { dispatch } = this.props
            this.props.component.fetchInProgress = true
            dispatch(getSelectOptions(this.props.component))
        }
    }

    componentDidMount() {
        const { dispatch /* , step */ } = this.props
        dispatch(fetchData(this.props.component.id, null, true))
    }
    componentWillReceiveProps(nextProps) {
        const { dispatch } = this.props
        if (
            (nextProps.component &&
                this.props.component.values.length === 0 &&
                nextProps.component.values.length >= 0) ||
            (nextProps.component &&
                this.props.component.values.length > 0 &&
                nextProps.component.values.length === 0)
        ) {
            if (!this.props.component.value && !!this.props.component.initialValue) {
                this.props.component.value = this.props.component.initialValue
            }

            if (
                this.props.component.hasOwnProperty('options') &&
                (this.props.component.values || []).length === 0 &&
                !this.props.component.fetchInProgress
            ) {
                this.props.component.fetchInProgress = true
                dispatch(getSelectOptions(this.props.component))
            }
        }
    }
    onValueChange(e) {
        const { dispatch, component } = this.props
        dispatch(updateComponent(component.id, { value: !!e.value?e.value:'' }))
    }
    renderOptions() {

        const { widget, component } = this.props
        if(component.id==='SETTORE_ATTIVITA_AZIENDA-DETTAGLIO_ATTIVITA_ECONOMICA' && !!component.values)
        {
        component.values.forEach(item=>{
            item.label=item.value.replace('##','  ')
            })
        }
        return (
            <div {...css(this.props.styles.component,  component.fullWidth && this.props.styles.singleField)}>
            <Select {...css(this.props.styles.try,this.props.styles['input--select'],
            component.status.indexOf('error') > -1 &&
              this.props.styles['input--invalid'])}
            name={component.id}
            value={component.value}
            onChange={event => {
                this.onValueChange(event)
            }}
            options={component.values} placeholder={component.cleanName}
            />
            </div>
        )
    }
    validateRequired() {
        const { component } = this.props
        if (
          component.validations &&
          component.validations.isRequired &&
          !component.isDisabled
        ) {
          return true
        }
        return false
      }

    render() {
        const { component } = this.props
        return (
            <div {...css(this.props.styles.divmain,this.props.styles.component,  component.fullWidth && this.props.styles.singleField)}>
                  <span
          {...css(
            this.props.styles.label,
            component.value !== '' && this.props.styles.labelActive,
          )}
        >
          {component.cleanName}
        </span>
                {this.renderOptions()}
    <p>{!!component.staticDescription && component.staticDescription}</p>
              
                <small {...css(this.props.styles['error-msg'])}>
          {camelize(component.errorMessage[0], true, true)}
               </small>
            </div>
        )
    }

}

DropDownSearch.propTypes = {
    widget: PropTypes.object.isRequired,
    component: PropTypes.object.isRequired,
    styles: PropTypes.object.isRequired,
    isInModal: PropTypes.bool
}

const mapStateToProps = (state /*, ownProps*/) => {
    const { step } = state
    /*return { component: components[ownProps.component.id] }*/
    return { step }
}
export default connect(mapStateToProps)(withStyles(Styles)(DropDownSearch))



// WEBPACK FOOTER //
// ./components/selectsearch/index.js